import { default as account_signin } from ":src/modules/account/signin/routes";
import { default as account_password_reset } from ":src/modules/account/password-reset/routes";

export default {
  BASE: "/auth",
  login: account_signin,
  password_reset: account_password_reset,
};
